import { forwardRef, type HTMLAttributes } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const gridAuto = cva('grid', {
  variants: {
    gap: { sm: 'gap-2', md: 'gap-3', lg: 'gap-4', xl: 'gap-6' },
    min: {
      sm: '[grid-template-columns:repeat(auto-fill,minmax(180px,1fr))]',
      md: '[grid-template-columns:repeat(auto-fill,minmax(240px,1fr))]',
      lg: '[grid-template-columns:repeat(auto-fill,minmax(320px,1fr))]',
    },
  },
  defaultVariants: { gap: 'md', min: 'md' },
});

export interface GridAutoProps
  extends HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof gridAuto> {}

export const GridAuto = forwardRef<HTMLDivElement, GridAutoProps>(function GridAuto(
  { gap, min, className, ...rest },
  ref,
) {
  return <div ref={ref} className={cn(gridAuto({ gap, min }), className)} {...rest} />;
});
